<template>
  <multiselect
    v-model="selected"
    :options="options"
    placeholder=""
    selectLabel=""
    selectedLabel="«"
    :multiple="isMulti === true"
    deselectLabel=""
    :allowEmpty="allowEmpty === true"
    :preselectFirst="true"
    :loading="isLoading"
    @input="onChange"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
  >
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="badge badge-primary mr-1 mt-1">
        <span class="text-truncate mr-1 mb-1">
          {{ option.nome }}
        </span>
        <span class="custom__remove badge" @mousedown.prevent.stop="remove(option)"> x </span>
      </span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'alreadySelected',
    'isRequired',
    'emptyLabel',
    'grupoSelected',
    'isDisabled',
    'isMulti',
    'allowEmpty',
    'nameField',
    'esporteSelected'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('selectChange', 'tipoSubevento', null);
        return;
      }
      this.$emit('selectChange', 'tipoSubevento', e);
    },
    setOptions(grupo) {
      this.options = [];
      this.isLoading = true;
      this.selected = '';
      let filter = null;
      if (this.esporteSelected) {
        filter = 'tipo_esporte = ' + this.esporteSelected;
      }
      this.$atenaList
        .getCommon('tipo_subevento', { columns: '*', filter: filter, order: 'nome' })
        .then((res) => {
          try {
            if (!this.isMulti) this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
            this.options = this.options.concat(res.data);
            if (this.alreadySelected) this.selected = this.alreadySelected;
            else if (!this.isMulti) this.selected = { id: '', nome: this.$i18n.t(this.emptyLabel) };

            if (this.nameField?.length && this.isMulti) {
              this.$nextTick(() => {
                this.selected = this.$util.getObjectRaw(
                  this.options.filter((o) => {
                    return this.nameField.includes(o.id);
                  })
                );
              });
            }
          } catch (error) {
            console.log(error);
          }

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },

  watch: {
    grupoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    },
    esporteSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    }
  },

  created() {
    this.setOptions(this.grupoSelected);
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
